/**
 * Lost Password template part entry.
 *
 * Importing the SCSS here makes Vite bundle the part's CSS alongside its JS.
 * Password show/hide toggle plus a client-side "passwords match" check for
 * the reset-password view (server-side validation in WooCommerce's own
 * WC_Form_Handler::process_reset_password() remains authoritative).
 */

import './index.scss';

const wrappers = document.querySelectorAll('.lost-password');

if (wrappers.length) {
	const passwordToggles = document.querySelectorAll('[data-lost-password-toggle]');

	passwordToggles.forEach((toggle) => {
		const field = toggle.closest('.lost-password__password');
		const input = field?.querySelector('input');

		if (!input) return;

		const showIcon = toggle.querySelector('.lost-password__eye-icon--show');
		const hideIcon = toggle.querySelector('.lost-password__eye-icon--hide');

		toggle.addEventListener('click', () => {
			const isVisible = input.type === 'text';

			input.type = isVisible ? 'password' : 'text';
			toggle.setAttribute('aria-pressed', String(!isVisible));
			toggle.setAttribute(
				'aria-label',
				isVisible ? toggle.dataset.labelShow : toggle.dataset.labelHide
			);
			showIcon?.toggleAttribute('hidden', !isVisible);
			hideIcon?.toggleAttribute('hidden', isVisible);
		});
	});

	const form = document.querySelector('.lost-password__form');
	const password = form?.querySelector('#password_1');
	const passwordConfirm = form?.querySelector('#password_2');

	if (password && passwordConfirm) {
		const validateMatch = () => {
			const mismatch = passwordConfirm.value !== password.value;
			passwordConfirm.setCustomValidity(
				mismatch ? passwordConfirm.dataset.mismatchMessage : ''
			);
		};

		password.addEventListener('input', validateMatch);
		passwordConfirm.addEventListener('input', validateMatch);
	}
}
